export abstract class Media {
  alias: 's' | 'm' | 'l' | 'xl';
  windowHeight: number;
  windowWidth: number;
}
